"use client"

// No icons needed for simplified tabs

import Accordion from "./accordion"
import { HttpTypes } from "@medusajs/types"

type ProductTabsProps = {
  product: HttpTypes.StoreProduct
}

const ProductTabs = ({ product }: ProductTabsProps) => {
  const tabs = [
    {
      label: "Product Information",
      component: <ProductDescriptionTab product={product} />,
    },
  ]

  return (
    <div className="w-full">
      <Accordion type="multiple">
        {tabs.map((tab, i) => (
          <Accordion.Item
            key={i}
            title={tab.label}
            headingSize="medium"
            value={tab.label}
          >
            {tab.component}
          </Accordion.Item>
        ))}
      </Accordion>
    </div>
  )
}

const ProductDescriptionTab = ({ product }: ProductTabsProps) => {
  // Define the attributes we want to display if they exist
  const attributes = [
    { label: "Material", value: product.material },
    { label: "Country of origin", value: product.origin_country },
    { label: "Type", value: product.type?.value },
    { label: "Weight", value: product.weight ? `${product.weight} g` : null },
    {
      label: "Dimensions",
      value: product.length && product.width && product.height
        ? `${product.length}L x ${product.width}W x ${product.height}H`
        : null
    },
  ]

  // Filter out attributes that don't have values
  const availableAttributes = attributes.filter(attr => attr.value)

  return (
    <div className="text-small-regular py-8 text-white/80">
      {/* Product description */}
      <div className="mb-8">
        <p className="whitespace-pre-line">
          {product.description}
        </p>
      </div>

      {/* Only show attributes section if there are attributes with values */}
      {availableAttributes.length > 0 && (
        <div className="mt-8 border-t border-white/10 pt-8">
          <h3 className="font-semibold mb-6 text-white">Product Specifications</h3>
          <div className="grid grid-cols-1 medium:grid-cols-2 gap-6">
            {availableAttributes.map((attr, index) => (
              <div key={index} className="flex flex-col">
                <span className="font-semibold text-white/90">{attr.label}</span>
                <span>{attr.value}</span>
              </div>
            ))}
          </div>
        </div>
      )}
    </div>
  )
}

export default ProductTabs
